import { configureStore } from "@reduxjs/toolkit";

import common from "../features/admin/common/Slice";
import drivingSchool from "../features/admin/Driving_school_details/slice"
import couponVerify from "../features/admin/coupon_verify/slice"
import vendorSubscription from "../features/admin/VendorSubscription/slice"
import contactus from "./contactus";

import auth from "./auth";

//store
export const store = configureStore({
  reducer: {
    vendorSubscription:vendorSubscription,
    couponVerify:couponVerify,
    drivingSchool:drivingSchool,
    common: common,
    contactus,
    auth,
  },
});
